import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ICardHeaderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    CardPartContentProps
} from "../../type";
import {
    flattenCardChildren,
    getCardPartKind
} from "../../util";
import {
    withCardContext
} from "../../context";

const CardHeaderContent: FC<CardPartContentProps<ICardHeaderProps>> = ({
    customTheme: customThemeProp,
    isDivided = false,
    children,
    context,
    style,
    ...props
}) => {
    const {
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const {
        container: containerDynamicStyle,
        text: textDynamicStyle
    } = useStyles({
        inset: context.inset,
        isDivided,
        borders,
        colors,
        spaces
    });

    const nodes = flattenCardChildren(children);

    const actionNodes = nodes.filter((node) => getCardPartKind(node) === "action");

    const textNodes = nodes.filter((node) => getCardPartKind(node) !== "action");

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            context.isPressable ? stylesheet.passThrough : undefined,
            containerDynamicStyle
        ]}
    >
        <View
            style={[
                stylesheet.text,
                context.isPressable ? stylesheet.inert : undefined,
                textDynamicStyle
            ]}
        >
            {textNodes}
        </View>
        {actionNodes}
    </View>;
};
export default withCardContext("header", CardHeaderContent);
